import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { Placement } from "tippy.js";
import styled, { css } from "styled-components";

import { borderRadius, boxShadow, colors } from "shared/styles/constants";

export interface StyledTippyInterface {
  placement: Placement;
}

export const ToolTipStyles = css`
  background-color: ${colors.white} !important;
  border-radius: ${borderRadius.s};
  box-shadow: ${boxShadow.l};
  padding: 0px !important;

  color: ${colors.black} !important;

  text-align: center;
`;

export const StyledTippy = styled(Tippy)<StyledTippyInterface>`
  ${ToolTipStyles}

  .tippy-arrow {
    &:before {
      border-top-color: ${colors.white} !important;
      transform: scale(0.8);
    }

    ${({ placement }) =>
      placement === "top-end" &&
      css`
        left: auto !important;
        right: 8px !important;
        transform: none !important;
      `}
  }
`;
